// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-blue-small-item/banner-blue-small-item.component.scss
// module id = 384
// module chunks = 0